// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__3ERfl","logo":"Header_logo__3jhpL","headerContent":"Header_headerContent__3ygbm"};